/* eslint-disable */

const BloomFilter = require('./vendor/bloomfilter');
const Utils = require('./utils');

const utils = new Utils();
const DEFAULT_FILTER_VALUE = 32 * 256;

/**
* Constructor for BloomFilterManager
* @constructor
* @param filterName
*/
export class BloomFilterManager {
    constructor(filterName) {
        this.filterName = filterName;
        this.filter = new BloomFilter(DEFAULT_FILTER_VALUE, 16);
    }

    /**
    * OVerride bloomfilter
    * @param {[[Type]]} newFilter [[Description]]
    */
    override(newFilter) {
        if (typeof newFilter === 'string' && newFilter !== '') {
            newFilter = utils.handledParse(newFilter, []);
        }

        if (utils.isArray(newFilter) && newFilter.length === 0) {
            newFilter = DEFAULT_FILTER_VALUE;
        }

        this.filter = new BloomFilter(newFilter, 16);
    }

    /**
    * Checking if value is valid and adding to filter
    * @param item
    */
    add(item) {
        if (item && item !== '') {
            this.filter.add(item);
        }
    }

    /**
    * Get the value of the cached filter from store
    * @param item
    */
    getCleanArray() {
        return [].slice.call(this.filter.buckets);
    }

    /**
    * Checking if value is valid and exists in the filter
    * @param item
    * @return Boolean
    */
    contains(item) {
        if (item && item !== '') {
            return this.filter.test(item);
        }

        return false;
    }

    /**
    * If item does not exist, add it to filter.
    * @param item
    */
    checkOrAdd(item) {
        if (item && item !== '') {
            if (!this.contains(item)) {
                this.add(item);
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./assets/js/BloomFilterManager.js
 **/